import {
	ActionTypes,
	Location,
	SEARCH_BARCODE_FULFILLED,
	SEARCH_BARCODE,
	Stock
} from '../types'

interface DataState {
	product: Record<string, string> | null
	option: Record<string, string> | null
	price: number | null
	location: Location[]
	stocks: Stock[]
	bestBefore: number | null
}

const initialState = {
	product: null,
	option: null,
	price: null,
	location: [],
	stocks: [],
	bestBefore: 0,
}

export default function reducer(state: DataState = initialState, action: ActionTypes): DataState {
	switch (action.type) {
		case SEARCH_BARCODE:
			return initialState

		case SEARCH_BARCODE_FULFILLED:
			return {
				...state,
				product: action.payload.product,
				option: action.payload.option,
				price: action.payload.price,
				location: action.payload.location,
				stocks: action.payload.bestBefore !== null && action.payload.bestBefore < 2 ? [] : action.payload.stocks,
				bestBefore: action.payload.bestBefore,
			}

		default:
			return state
	}
}
